<template>
  <div class="container" id="Login">
    <div class="login-wrap">
      <div class="login-frm">
        <form>
          <div class="login-frm_hd">
            <h2>用户登录</h2>
          </div>
          <div class="login-frm_bd">
            <ul>
              <li class="item-input ">
                <i class="icon icon-username"></i
                ><input
                  class="s-input"
                  type="text"
                  name="txt-username"
                  v-model="loginForm.corporateAccount"
                  value=""
                  placeholder="输入企业账号"
                />
              </li>
              <li class="item-input">
                <i class="icon icon-password"></i
                ><input
                  class="s-input"
                  type="password"
                  name="txt-password"
                  v-model="loginForm.password"
                  placeholder="输入登录密码"
                />
              </li>
              <li class="item-flex">
                <div class="item-input" style="flex: 1; display: flex; justify-content: center; align-items: center;">
                  <i class="icon icon-checkcode"></i
                  ><input
                    class="s-input"
                    type="text"
                    v-model="loginForm.code"
                    @keyup.enter="handlerLogin"
                    name="txt-checkcode"
                    placeholder="输入验证码"
                  />
                </div>
                <div class="item-icode" @click.stop="loadCaptcha"><img :src="imgCaptcha" /></div>
              </li>
              <li class="item-flex item-forget">
                <div style="flex: 1;">
                  <label><input type="checkbox" name="vehicle" value="Car" checked="checked" />记住用户名</label>
                </div>
                <!-- <a href="javascript:;">忘记密码</a> -->
              </li>
              <li>
                <a class="btn-login" href="javascript:;" @click="handlerLogin"
                  ><a-spin :spinning="spinning">登录</a-spin></a
                >
              </li>
            </ul>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import utils from 'assets/js/util'

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        corporateAccount: '',
        password: '',
        code: '',
        uuid: ''
      },
      userToken: {
        accessToken: '',
        refreshToken: ''
      },

      imgCaptcha: '',
      spinning: false,
      enterpriseInformation: {}
    }
  },
  methods: {
    handlerLogin: function() {
      let params = {
        corporateAccount: this.loginForm.corporateAccount,
        password: this.loginForm.password === '' ? '' : this.$md5(this.loginForm.password),
        code: this.loginForm.code,
        uuid: this.loginForm.uuid
      }
      if (utils.isNullOrEmpty(params.corporateAccount)) {
        this.$message.error('请输入账号')
        return
      }
      if (utils.isNullOrEmpty(params.password)) {
        this.$message.error('请输入密码')
        return
      }
      if (utils.isNullOrEmpty(params.code)) {
        this.$message.error('请输入验证码')
        return
      }
      this.spinning = true
      this.$post('enterpriseInformation/login', params, true)
        .then(res => {
          // 存至store
          if (res.data.success) {
            let objTemp = res.data.result
            localStorage.setItem('token', JSON.stringify(objTemp.token))
            // localStorage.setItem('token',JSON.stringify({accessToken:"eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyQ29udGV4dCI6IntcInVzZXJuYW1lXCI6XCJjZXNcIixcIm5pY2tOYW1lXCI6XCLmtYvor5VcIixcImZhY2VcIjpcImh0dHA6Ly9tYW5hZ2VyLmZhbnJvbmctcWlhbmR1YW4uaGluYS1nb2xkLmNvbS9pbWFnZXMvZmFucm9uZy9zeXN0ZW0vMjAyMjgvOTk2ZmZkMDVlYzVkNDFlOTllN2MyNWYzZjZkOGFhMWQuanBnXCIsXCJpZFwiOlwiMTUzNjY0MTQ0NzYzNjI1MDYyNVwiLFwibG9uZ1Rlcm1cIjp0cnVlLFwicm9sZVwiOlwiTUFOQUdFUlwiLFwiaXNTdXBlclwiOmZhbHNlfSIsInN1YiI6ImNlcyIsImV4cCI6MTY4NTQxMTUzOX0.B65D8g12exNom5uHsfawIh16LfGTVkUNpYDQQFYSFOU"}) )
            localStorage.setItem('userInfo', JSON.stringify(objTemp.enterpriseInformation))

            this.$store.dispatch('actUserCode', objTemp.token)
            this.$store.dispatch('actUserInfo', objTemp.enterpriseInformation)
            this.spinning = false
            this.$router.replace('home')
          } else {
            this.spinning = false
            this.$message.error(res.data.message)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

    // 加载验证码
    loadCaptcha: function() {
      let params = {
        uuid: this.loginForm.uuid
      }
      this.$get('enterpriseInformation/captcha', params)
        .then(res => {
          this.imgCaptcha = res.img
          this.loginForm.uuid = res.uuid
        })
        .catch(err => {
          console.log(err)
        })
    }
  },

  created: function() {
    // 加载验证码
    this.loadCaptcha()
  },

  mounted: function() {}
}
</script>

<style scoped>
html,
body {
  margin: 0px;
  padding: 0px;
  height: 100%;
  font: 12px/1.5 Arial;
  color: #ccc;
}

img {
  border: 0px;
}

em {
  font-style: normal;
}

ul,
li,
form,
p,
dl,
dt,
dd {
  margin: 0;
  padding: 0;
}

ul,
li {
  list-style: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
  font-size: 12px;
  font-weight: normal;
}

.container {
  height: 100vh;
  min-height: 800 rpx;
  background: url('~assets/login/login_bg.png') no-repeat;
  background-size: 100% 100%;
}

.clearfix {
  *zoom: 1;
}

.clearfix:before {
  content: '';
  height: 0;
  line-height: 0;
  display: table;
}

.clearfix:after {
  content: '';
  height: 0;
  line-height: 0;
  display: table;
  clear: both;
}

.login-wrap {
  clear: both;
  width: 1600px;
  height: 720px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: url('http://lgp6.cn/filedownload/login_wrap.bf39c1ef.png') center center / contain no-repeat;
  display: flex;
  justify-content: center;
}

.login-frm {
  width: 600px;
  height: 560px;
  margin-top: 80px;
  /* float: right; */
  background-color: #fff;
  box-shadow: 0px 0px 6px #45a3ff;
  border-radius: 6px;
}

.login-frm form {
  height: 560px;
}

.login-frm_hd {
  height: 12.5%;
  position: relative;
}

.login-frm_hd:after {
  position: absolute;
  content: '';
  width: 100%;
  height: 1px;
  left: 0;
  bottom: 0;
  background: #d8d8d8;
}

.login-frm_hd h2 {
  height: 100%;
  line-height: 100%;
  text-align: center;
  font-size: 24px;
  line-height: 70px;
  color: #45a3ff;
  font-weight: 700;
}

.login-frm_bd {
  padding: 56px;
}

.login-frm_bd ul {
}

.login-frm_bd ul li {
  margin: 32px 0 0 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.login-frm_bd ul li:first-child {
  margin-top: 0;
}

.login-frm_bd ul li:last-child {
  margin-top: 20px;
}

.login-frm_bd ul li.item-forget {
  height: 30px;
  line-height: 30px;
  margin-top: 20px;
  font-size: 16px;
  color: #9a9a9a;
}

.login-frm_bd ul li.item-forget a {
  color: #9a9a9a;
  text-decoration: none;
}

.login-frm_bd ul li.item-forget a:hover {
  color: #45a3ff;
}

.item-input {
  position: relative;
  border: 1px solid #d8d8d8;
  height: 60px;
  padding: 0 12px 0 50px;
}

.item-flex {
  display: flex;
  flex: 1;
  justify-content: space-between;
}

.item-icode {
  width: 100px;
  height: 60px;
  padding-left: 10px;
}

.item-icode img {
  width: 90px;
  height: 60px;
}

.s-input {
  border: 0;
  box-sizing: border-box;
  width: 100%;
  height: 48px;
  line-height: 48px;
  font-size: 16px;
  color: #333;
  outline: 0;
}

.btn-login {
  width: 100%;
  height: 60px;
  background: #45a3ff;
  font: 24px/60px 'Microsoft YaHei', '\5FAE\8F6F\96C5\9ED1';
  text-align: center;
  border: 0;
  display: block;
  color: #fff;
  text-decoration: none;
  border-radius: 8px;
}

.icon {
  position: absolute;
  display: block;
  width: 30px;
  height: 30px;
  left: 8px;
  top: 14px;
}

.icon-username {
  background: url('~assets/login/icon_username.png') no-repeat;
  background-size: 30px 30px;
}

.icon-password {
  background: url('~assets/login/icon_password.png') no-repeat;
  background-size: 30px 30px;
}

.icon-checkcode {
  background: url('~assets/login/icon_checkcode.png') no-repeat;
  background-size: 30px 30px;
}
</style>
